(function () {
  if (window.__vlSectionsLoaded) return;
  window.__vlSectionsLoaded = true;

  function retargetAll(handle, title, variantId) {
    if (!handle) return;
    document.querySelectorAll('[data-pp-visualize]').forEach(function (node) {
      node.setAttribute('data-product-handle', handle);
      if (title) node.setAttribute('data-product-title', title);
      if (variantId) node.setAttribute('data-variant-id', String(variantId));
      else node.removeAttribute('data-variant-id');
    });
  }

  function openVisualizer() {
    var root = document.querySelector('[data-pp-visualize]');
    if (!root) return;
    var opener =
      root.querySelector('[data-pp-open]') ||
      root.querySelector('button') ||
      root.querySelector('[role="button"]') ||
      root.querySelector('a');
    if (opener && typeof opener.click === 'function') opener.click();
  }

  function trackVlCta(placement, handle) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'vl_visualize_cta',
        placement: placement,
        product_handle: handle || ''
      });
    } catch (e) {}
  }

  function applyHeroVisuals(root, chip) {
    if (!root || !chip) return;
    var tileUrl = chip.getAttribute('data-tile-url') || '';
    var roomUrl = chip.getAttribute('data-room-url') || '';
    var tiles = root.querySelector('[data-vl-tiles]');
    if (tiles && tileUrl) {
      tiles.style.backgroundImage = 'url("' + tileUrl + '")';
      root.style.setProperty('--vl-tile-url', 'url("' + tileUrl + '")');
    }
    /* Swap the matted room photo only — no soft-fade fill behind it. */
    var after = root.querySelector('[data-vl-proof-after]');
    if (roomUrl && after && after.tagName === 'IMG') {
      after.setAttribute('src', roomUrl);
      if (after.hasAttribute('srcset')) after.removeAttribute('srcset');
    }
    var nameEl = root.querySelector('[data-vl-selected-name]');
    if (nameEl) nameEl.textContent = chip.getAttribute('data-product-title') || '';
  }

  function initHero(root) {
    if (!root || root.dataset.vlReady === '1') return;
    root.dataset.vlReady = '1';
    var chips = root.querySelectorAll('[data-vl-chip]');
    var active = root.querySelector('[data-vl-chip][aria-pressed="true"]') || chips[0];
    applyHeroVisuals(root, active);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        var handle = chip.getAttribute('data-product-handle') || '';
        var title = chip.getAttribute('data-product-title') || '';
        var variantId = chip.getAttribute('data-variant-id') || '';
        applyHeroVisuals(root, chip);
        retargetAll(handle, title, variantId);
        trackVlCta('hero_chip', handle);
      });
    });
  }

  function initGrid(root) {
    if (!root || root.dataset.vlReady === '1') return;
    root.dataset.vlReady = '1';
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-vl-visualize-handle]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      var handle = btn.getAttribute('data-vl-visualize-handle') || '';
      var title = btn.getAttribute('data-product-title') || '';
      var variantId = btn.getAttribute('data-variant-id') || '';
      retargetAll(handle, title, variantId);
      trackVlCta('grid_card', handle);
      openVisualizer();
    });
  }

  function initFinalCta(root) {
    if (!root || root.dataset.vlReady === '1') return;
    root.dataset.vlReady = '1';
    var btn = root.querySelector('[data-vl-final-cta]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-product-handle') || '';
      var title = btn.getAttribute('data-product-title') || '';
      if (handle) retargetAll(handle, title, btn.getAttribute('data-variant-id') || '');
      trackVlCta('final_cta', handle);
      var hero = document.querySelector('[data-vl-hero]');
      if (hero && typeof hero.scrollIntoView === 'function') {
        hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      openVisualizer();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vl-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-vl-grid]').forEach(initGrid);
    (scope || document).querySelectorAll('[data-vl-final-cta-root]').forEach(initFinalCta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('pp-visualize:try-another', function () {
    var grid = document.querySelector('#vl-grid');
    if (grid && typeof grid.scrollIntoView === 'function') {
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
